export default function Accommodation(props) {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 35 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
      <g clip-path="url(#clip0_527_2936)">
        <g clip-path="url(#clip1_527_2936)">
          <path
            d="M31.6671 15.3651L18.2373 3.42747C17.9644 3.18467 17.6118 3.05054 17.2465 3.05054C16.8812 3.05054 16.5286 3.18467 16.2557 3.42747L2.8259 15.3651C2.52987 15.6278 2.35036 15.9975 2.32686 16.3926C2.30334 16.7877 2.43778 17.176 2.70055 17.4721C2.96334 17.7681 3.33295 17.9476 3.72809 17.9711C4.12322 17.9946 4.51151 17.8602 4.80754 17.5974L5.30887 17.1512V31.4032C5.30887 31.799 5.46611 32.1785 5.74601 32.4584C6.0258 32.7382 6.4053 32.8954 6.80115 32.8954H27.6918C28.0877 32.8954 28.4672 32.7382 28.747 32.4584C29.0269 32.1785 29.1841 31.799 29.1841 31.4032V17.1512L29.6855 17.5974C29.9815 17.8602 30.3697 17.9946 30.7649 17.9711C30.9605 17.9595 31.152 17.9093 31.3283 17.8237C31.5047 17.7381 31.6624 17.6186 31.7924 17.4721C31.9226 17.3255 32.0225 17.1547 32.0866 16.9695C32.1508 16.7843 32.1778 16.5882 32.1661 16.3926C32.1545 16.1969 32.1044 16.0054 32.0188 15.8292C31.9332 15.6529 31.8137 15.4952 31.6671 15.3651ZM13.0444 29.911C13.3484 29.0387 13.9161 28.2827 14.6691 27.7477C15.4221 27.2126 16.3229 26.9252 17.2465 26.9252C18.1701 26.9252 19.0709 27.2126 19.8239 27.7477C20.5769 28.2827 21.1446 29.0387 21.4486 29.911H13.0444ZM15.0082 21.7039C15.0082 21.2612 15.1395 20.8284 15.3855 20.4604C15.6313 20.0924 15.981 19.8054 16.3899 19.636C16.7989 19.4666 17.249 19.4222 17.6832 19.5086C18.1173 19.595 18.5162 19.8082 18.8292 20.1212C19.1422 20.4343 19.3554 20.833 19.4418 21.2672C19.5281 21.7015 19.4838 22.1515 19.3145 22.5605C19.145 22.9695 18.8581 23.3191 18.49 23.565C18.1219 23.8109 17.6892 23.9422 17.2465 23.9422C16.6531 23.9414 16.0843 23.7053 15.6647 23.2857C15.2451 22.8662 15.009 22.2973 15.0082 21.7039ZM26.1997 29.911H24.5568C24.3504 28.9216 23.9453 27.9846 23.3658 27.1565C22.7863 26.3286 22.0447 25.6269 21.1859 25.0942C22.0085 24.1558 22.4642 22.9518 22.4692 21.7039C22.4692 20.3188 21.9189 18.9903 20.9395 18.011C19.9601 17.0315 18.6317 16.4812 17.2465 16.4812C15.8613 16.4812 14.5329 17.0315 13.5535 18.011C12.574 18.9903 12.0238 20.3188 12.0238 21.7039C12.0288 22.9518 12.4845 24.1558 13.3071 25.0942C12.448 25.6268 11.7062 26.3284 11.1264 27.1564C10.5467 27.9844 10.1412 28.9215 9.93476 29.911H8.29331V14.4981L17.2465 6.5402L26.1997 14.4981V29.911Z"
            fill="#6DDFE2"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_527_2936">
          <rect
            width="34.4138"
            height="34.4138"
            fill="white"
            transform="translate(0.0292969 0.756348)"
          />
        </clipPath>
        <clipPath id="clip1_527_2936">
          <rect
            width="34.4138"
            height="34.4138"
            fill="white"
            transform="translate(0.0292969 0.756348)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
